"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.getOrCreateAccount = void 0;
var invariant_1 = __importDefault(require("invariant"));
var logs_1 = require("@ledgerhq/logs");
var promise_1 = require("../promise");
var errors_1 = require("./errors");
var restoreWithAccountCreationInfo = {
    tezos: true,
    stellar: true,
    algorand: true
};
exports.getOrCreateAccount = (0, promise_1.atomicQueue)(function (_a) {
    var core = _a.core, coreWallet = _a.coreWallet, _b = _a.account, xpub = _b.xpub, index = _b.index, currency = _b.currency;
    return __awaiter(void 0, void 0, void 0, function () {
        var coreAccount, err_1, accountCreationInfos, chainCodes, publicKeys, derivations, owners, newAccountCreationInfos, account, extendedInfos, infosIndex, extendedKeys, owners, derivations, newExtendedKeys, account;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    (0, logs_1.log)("libcore", "getOrCreateAccount", {
                        xpub: xpub,
                        index: index
                    });
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, , 20]);
                    return [4 /*yield*/, coreWallet.getAccount(index)];
                case 2:
                    coreAccount = _c.sent();
                    return [3 /*break*/, 20];
                case 3:
                    err_1 = _c.sent();
                    if (!(0, errors_1.isNonExistingAccountError)(err_1)) {
                        throw err_1;
                    }
                    (0, logs_1.log)("libcore", "no account existed. restoring...");
                    (0, invariant_1["default"])(xpub, "xpub is missing. Please reimport the account.");
                    if (!xpub)
                        return [2 /*return*/];
                    if (!restoreWithAccountCreationInfo[currency.id]) return [3 /*break*/, 11];
                    return [4 /*yield*/, coreWallet.getAccountCreationInfo(index)];
                case 4:
                    accountCreationInfos = _c.sent();
                    return [4 /*yield*/, accountCreationInfos.getChainCodes()];
                case 5:
                    chainCodes = _c.sent();
                    return [4 /*yield*/, accountCreationInfos.getPublicKeys()];
                case 6:
                    publicKeys = _c.sent();
                    return [4 /*yield*/, accountCreationInfos.getDerivations()];
                case 7:
                    derivations = _c.sent();
                    return [4 /*yield*/, accountCreationInfos.getOwners()];
                case 8:
                    owners = _c.sent();
                    publicKeys.push(xpub);
                    (0, logs_1.log)("libcore", "AccountCreationInfo.init", {
                        index: index,
                        owners: owners,
                        derivations: derivations,
                        publicKeys: publicKeys,
                        chainCodes: chainCodes
                    });
                    return [4 /*yield*/, core.AccountCreationInfo.init(index, owners, derivations, publicKeys, chainCodes)];
                case 9:
                    newAccountCreationInfos = _c.sent();
                    return [4 /*yield*/, coreWallet.newAccountWithInfo(newAccountCreationInfos)];
                case 10:
                    account = _c.sent();
                    return [2 /*return*/, account];
                case 11: return [4 /*yield*/, coreWallet.getExtendedKeyAccountCreationInfo(index)];
                case 12:
                    extendedInfos = _c.sent();
                    return [4 /*yield*/, extendedInfos.getIndex()];
                case 13:
                    infosIndex = _c.sent();
                    return [4 /*yield*/, extendedInfos.getExtendedKeys()];
                case 14:
                    extendedKeys = _c.sent();
                    return [4 /*yield*/, extendedInfos.getOwners()];
                case 15:
                    owners = _c.sent();
                    return [4 /*yield*/, extendedInfos.getDerivations()];
                case 16:
                    derivations = _c.sent();
                    extendedKeys.push(xpub);
                    return [4 /*yield*/, core.ExtendedKeyAccountCreationInfo.init(infosIndex, owners, derivations, extendedKeys)];
                case 17:
                    newExtendedKeys = _c.sent();
                    return [4 /*yield*/, coreWallet.newAccountWithExtendedKeyInfo(newExtendedKeys)];
                case 18:
                    account = _c.sent();
                    return [2 /*return*/, account];
                case 19: return [3 /*break*/, 20];
                case 20: return [2 /*return*/, coreAccount];
            }
        });
    });
}, function (_a) {
    var account = _a.account;
    return account.id || "";
});
//# sourceMappingURL=getOrCreateAccount.js.map